import React from 'react';

/**
 * 결제 컴포넌트 속성 패널 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const PaymentProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '결제 페이지 제목',
        control: 'TextField',
        defaultValue: '결제하기'
      },
      {
        name: 'componentProps.emptyText',
        label: '장바구니 빈 상태 메시지',
        control: 'TextField',
        defaultValue: '장바구니가 비어 있습니다.'
      },
      {
        name: 'componentProps.shippingFee',
        label: '배송비',
        control: 'NumberField',
        defaultValue: 4000,
        min: 0,
        description: '배송비 (원). 5만원 이상 구매시 무료배송으로 자동 설정됩니다.'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '40px 0'
      },
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.marginBottom',
        label: '하단 여백',
        control: 'TextField',
        defaultValue: '100px'
      },
      {
        name: 'className',
        label: 'CSS 클래스',
        control: 'TextField',
        defaultValue: 'payment-component-wrapper padding-tb-40'
      }
    ]
  },
  {
    group: '결제 설정',
    properties: [
      {
        name: 'componentProps.useVirtualAccount',
        label: '무통장 입금 사용',
        control: 'Toggle',
        defaultValue: true,
        description: '무통장 입금 옵션을 사용할지 여부'
      },
      {
        name: 'componentProps.useTransfer',
        label: '계좌 이체 사용',
        control: 'Toggle',
        defaultValue: false,
        description: '계좌 이체 옵션을 사용할지 여부'
      }
    ]
  }
];

export default PaymentProperties; 